export default "__VITE_ASSET__DqSsPpRt__"